import React, { useState } from 'react';
import styled from 'styled-components';
import { FileCopy, Visibility, VisibilityOff } from '@material-ui/icons/';
import { useDispatch, useSelector } from 'react-redux';
import { InputTextWithLabel } from '../../../molecules';
import { RootState } from '../../../redux/root';
import { setPermittingPristine, setSelectedJurisdiction } from '../../../redux/slices/wikiSlice';
import { copyToClipboard } from '../../../utils';

const CredentialsComponent = ({ errors }) => {
  const selectedJurisdiction = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const dispatch = useDispatch();
  const [showLogin, setShowLogin] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const setLogin = username => {
    const _selectedJuri = {
      ...selectedJurisdiction,
      permitting: {
        ...selectedJurisdiction.permitting,
        username,
      },
    };

    dispatch(setSelectedJurisdiction(_selectedJuri));
    dispatch(setPermittingPristine(false));
  };

  const setPassword = password => {
    const _selectedJuri = {
      ...selectedJurisdiction,
      permitting: {
        ...selectedJurisdiction.permitting,
        password,
      },
    };

    dispatch(setSelectedJurisdiction(_selectedJuri));
    dispatch(setPermittingPristine(false));
  };

  return (
    <>
      <Credentials>
        <ControlWithIcon>
          <InputTextWithLabel
            name="username"
            label="Login"
            error={errors?.username}
            type={showLogin ? 'text' : 'password'}
            value={selectedJurisdiction?.permitting?.username}
            onChange={e => setLogin(e.target.value)}
            autoComplete="custom-do-not-fill"
          />
          <IconRow>
            <IconButton title={showLogin ? 'Hide' : 'View'} onClick={() => setShowLogin(s => !s)}>
              {showLogin ? <VisibilityOff /> : <Visibility />}
            </IconButton>
            <IconButton title="Copy" onClick={() => copyToClipboard(selectedJurisdiction?.permitting?.username)}>
              <FileCopy />
            </IconButton>
          </IconRow>
        </ControlWithIcon>
        <ControlWithIcon>
          <InputTextWithLabel
            name="password"
            label="Keys"
            error={errors?.password}
            type={showPassword ? 'text' : 'password'}
            value={selectedJurisdiction?.permitting?.password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="custom-do-not-fill"
          />
          <IconRow>
            <IconButton title={showPassword ? 'Hide' : 'View'} onClick={() => setShowPassword(s => !s)}>
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
            <IconButton title="Copy" onClick={() => copyToClipboard(selectedJurisdiction?.permitting?.password)}>
              <FileCopy />
            </IconButton>
          </IconRow>
        </ControlWithIcon>
      </Credentials>
    </>
  );
};

export default CredentialsComponent;

const ControlWithIcon = styled.div`
  position: relative;
  flex: 1 1 0;
  min-width: 0;
`;

const Credentials = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
`;

const IconRow = styled.div`
  position: absolute;
  top: 33px;
  right: 4px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;

const IconButton = styled.button.attrs({ type: 'button' })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--neutral-500);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  svg {
    font-size: 1.05rem;
  }

  &:hover {
    background: var(--primary-50);
    color: var(--primary-600);
  }

  &:active {
    background: var(--primary-100);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;
